/*
  The canonical set of agent tool lifecycle events — UI side-effects a tool publishes as it
  runs, ingested on the client. Reference the KEY in code; the string VALUE is the wire name
  on metadata.lifecycleEvents. Tense tracks the lifecycle (present-continuous on start, past
  on complete). "Agent tool lifecycle" — not bare "lifecycle" — keeps it distinct from
  @shopmy/entity-lifecycle events.
*/

const AGENT_TOOL_LIFECYCLE_EVENT = Object.freeze({
  UPDATING_OPPORTUNITY: 'updating_opportunity',
  UPDATED_OPPORTUNITY:  'updated_opportunity',
  CREATED_OPPORTUNITY:  'created_opportunity',

  UPDATING_OPPORTUNITY_PLAN:     'updating_opportunity_plan',
  CREATED_OPPORTUNITY_PLAN:      'created_opportunity_plan',
  UPDATED_OPPORTUNITY_PLAN:      'updated_opportunity_plan',
  ADDED_OPPORTUNITY_PLAN_USER:   'added_opportunity_plan_user',
  UPDATED_OPPORTUNITY_PLAN_USER: 'updated_opportunity_plan_user',
  DELETED_OPPORTUNITY_PLAN_USER: 'deleted_opportunity_plan_user',

  UPDATING_BRAND_LIST:     'updating_brand_list',
  CREATED_BRAND_LIST:      'created_brand_list',
  UPDATED_BRAND_LIST:      'updated_brand_list',
  DELETED_BRAND_LIST:      'deleted_brand_list',
  ADDED_BRAND_LIST_USER:   'added_brand_list_user',
  UPDATED_BRAND_LIST_USER: 'updated_brand_list_user',
  DELETED_BRAND_LIST_USER: 'deleted_brand_list_user',

  UPDATED_THREAD:       'updated_thread',
  SWITCHED_THREAD:      'switched_thread',

  // Chat Manager — creator inbox. CREATED_CHAT_INBOX navigates the operator to the new
  // inbox (the id rides toolOutput); the rest re-sync the open /chat surface + badges.
  SENT_CREATOR_MESSAGE:  'sent_creator_message',
  SENT_CREATOR_MESSAGES: 'sent_creator_messages',
  UPDATED_CHAT:          'updated_chat',
  CREATED_CHAT_INBOX:    'created_chat_inbox',
  UPDATED_CHAT_INBOX:    'updated_chat_inbox',

  HELLO_WORLD:          'hello_world' // smoke-test event; remove once the path is proven
});

const AGENT_TOOL_LIFECYCLE_EVENT_NAMES = Object.values(AGENT_TOOL_LIFECYCLE_EVENT);

const isAgentToolLifecycleEvent = name => AGENT_TOOL_LIFECYCLE_EVENT_NAMES.includes(name);

module.exports = {
  AGENT_TOOL_LIFECYCLE_EVENT,
  AGENT_TOOL_LIFECYCLE_EVENT_NAMES,
  isAgentToolLifecycleEvent
};
